const getLocationValidations = (menu, orderDetails, selectedLocation) => {
  const fulfillmentTypes = {
    'take-out': 'Takeout',
    curbside: 'Curbside',
    'drive-through': 'DriveThrough',
    delivery: 'Delivery',
    shipping: 'Shipping',
    'dine-in': 'DineIn'
  };

  const orderType = orderDetails.fulfillmentType === 'pick-up' ? orderDetails.pickupType : orderDetails.fulfillmentType;

  const parsedResult = selectedLocation.validations.reduce((reducerObj, validation) => {
    /**
      * For a selected location's validation rules with multiples of the same "fulfillmentType", the validation's "menuType" will be the discerning
      * factor in determining what the selected location's validation should be set.
      *
      * Parse the validation for a matched "menuType" with the order's menu type (ie. order.menuType),
      * in addition to parsing the list of validations and "caching" any validation (without a specified "menuType") that matches the order's
      * "fulfillmentType".
    */

    const isFulfillmentTypeMatch = validation.fulfillmentType === fulfillmentTypes[orderType];
    /** Instead of checking order.menuType check menu.menuType */
    if (isFulfillmentTypeMatch && validation.menuType === menu.menuType) {
      reducerObj.matchedMenuTypeValidation = validation;
    }
    else if (isFulfillmentTypeMatch && !validation.menuType) {
      reducerObj.matchedFulfillmentTypeValidation = validation;
    }

    return reducerObj;
  }, { matchedMenuTypeValidation: null, matchedFulfillmentTypeValidation: null });

  /*
   * If none of the validations and order details contain a match for a specified "menuType", but a match exists for the order's "fulfillmentType" AND the validation's "fulfillmentType",
   * use this validation.
  */
  return parsedResult.matchedMenuTypeValidation || parsedResult.matchedFulfillmentTypeValidation;
};

export default getLocationValidations;

/** NOTES:
 * Order Ahead orders are preconfigured with fulfillmentType == "pick-up" (see order/wrapper-page.vue and orders/normalizeOrderDetails);
 * fulfillmentType type of "pick-up" is a "catch-all" for all order ahead pickup types ('Take-out', 'Curbside', 'Drive-Through').
*/

